var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "mb-3" },
    [
      _c(
        "b-col",
        { attrs: { cols: "9" } },
        [
          _c(
            "div",
            {
              staticClass: "info",
              class: {
                invalid: !_vm.manufacture.isValid,
                "text-muted": !_vm.manufacture.isValid,
              },
            },
            [
              _vm._t("default"),
              _c("p", { staticClass: "my-2" }, [
                _c("small", [
                  _vm._v(_vm._s(_vm.glazing.meta.short_description)),
                ]),
              ]),
            ],
            2
          ),
          _vm._l(_vm.manufacture.problems, function (problem, idx) {
            return _c(
              "p",
              { key: idx, staticClass: "mb-0 text-danger manufacture" },
              [
                _c("small", [
                  _c("span", { staticClass: "material-icons mr-1" }, [
                    _vm._v("handyman"),
                  ]),
                  _vm._v(_vm._s(problem)),
                ]),
              ]
            )
          }),
          !_vm.delivery.isValid
            ? _c("p", { staticClass: "mb-0 text-danger delivery" }, [
                _c("small", [
                  _c("span", { staticClass: "material-icons mr-1" }, [
                    _vm._v("bus_alert"),
                  ]),
                  _vm._v("Delivery Not Available (Collection Only)"),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("b-col", { staticClass: "text-right", attrs: { cols: "3" } }, [
        _vm._v("£" + _vm._s(_vm.price)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }